// Teclado de letras pro totem (touch, sem teclado físico): QWERTY grande e
// espaço. Apagar fica no próprio campo (segurar limpa tudo) e o avançar é o
// AVANÇAR do rodapé — pedido do dono (09/09/2026).
import Tecla from "./Tecla";

const LINHAS = ["QWERTYUIOP", "ASDFGHJKL", "ZXCVBNM"];

export default function TecladoAlfabetico({ onLetra, onEspaco }) {
  const tecla = "h-14 md:h-16 rounded-xl text-2xl font-bold bg-zinc-800 text-zinc-100 hover:bg-zinc-700";
  return (
    <div className="w-full max-w-3xl mx-auto space-y-2" data-e2e="teclado-alfabetico">
      {LINHAS.map((linha, i) => (
        <div key={linha} className="flex justify-center gap-2" style={{ paddingLeft: i * 18, paddingRight: i * 18 }}>
          {linha.split("").map((l) => (
            <Tecla key={l} onPress={() => onLetra(l)} className={`${tecla} flex-1 max-w-[72px]`}>{l}</Tecla>
          ))}
        </div>
      ))}
      <div className="flex justify-center pt-1">
        <Tecla onPress={onEspaco} className={`${tecla} w-full max-w-md text-lg`}>ESPAÇO</Tecla>
      </div>
    </div>
  );
}
